// extracted by mini-css-extract-plugin
export default {"editorCustomImage":"text-editor_editorCustomImage__3EPor","textEditor":"text-editor_textEditor__Fby53"};